module.exports = __webpack_public_path__ + "media/images/icons/secure-119d9223fd3ba04d755a6a8ca0c11b32.svg";